import { useState, useMemo } from 'react'
import _orderBy from 'lodash/orderBy'
import { useTranslation } from 'react-i18next'
import { Chip, Table, TableBody, TableCell, TableHead, Typography, TableRow } from '@mui/material'
import { Box, Stack } from '@mui/system'
import Row from './Row'
import TableSortLabel from 'packages/ui/Table/TableSortLabel'

function CardSelection({
  accounts,
  nbSites,
  onRemoveAccount,
  onRemoveAccountParent,
  disabled,
  hasAccountParentBadge,
  accountParentTooltip
}) {
  const { t } = useTranslation()
  const [order, setOrder] = useState('asc')

  const handleDelete = account => {
    onRemoveAccount(account)
  }

  const handleRequestSort = () => {
    const isAsc = order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
  };

  const sortedAccounts = [...accounts].sort((a, b) => {
    if (order === 'asc') {
      return a.name.localeCompare(b.name);
    } else {
      return b.name.localeCompare(a.name);
    }
  });

  return (
    <Box
      sx={{
        border: 'solid 1px',
        borderColor: 'border.primary',
        borderRadius: '8px',
        minHeight: '460px',
        height: '100%',
        flex: 1
      }}>
      <Box sx={{ maxHeight: 500, m: 0 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell key={'label'}>
                <TableSortLabel
                  hideSortIcon={false}
                  active={order === 'label'}
                  direction={order}
                  onClick={handleRequestSort}
                  style={{
                    marginLeft: 12,
                    '&:active': {
                      color: 'primary.main'
                    }
                  }}>
                  <Stack flexDirection={'row'} alignItems={'center'} gap={1}>
                    <Typography
                      sx={{
                        color: 'primary.main',
                        fontWeight: '600',
                        lineHeight: '32px',
                        fontSize: '10px',
                        whiteSpace: 'nowrap'
                      }}
                      onClick={() => handleRequestSort()}>
                      {t('ui_elements.label')}
                    </Typography>
                  </Stack>
                </TableSortLabel>
              </TableCell>
              <TableCell key={'selected'} align="right" sx={{ maxWidth: '60px !important', width: '100%' }}>
                <Stack direction="row" alignItems="center" gap={1} justifyContent="flex-end">
                  <Typography
                    sx={{
                      fontSize: '10px',
                      whiteSpace: 'no-wrap'
                    }}>
                    {t('auth.admin.edit.sites.label')}
                  </Typography>
                  <Chip
                    sx={{
                      backgroundColor: 'background.primary',
                      color: 'content.secondary',
                      fontSize: '10px',
                      lineHeight: '15px',
                      fontWeight: 600
                    }}
                    size="small"
                    label={nbSites}
                  />
                </Stack>
              </TableCell>
            </TableRow>
          </TableHead>
        </Table>
        <Box sx={{ overflow: 'auto', maxHeight: 400 }}>
          <Table size="small" stickyHeader className="no-after">
            <TableBody>
              {sortedAccounts.map(account => {
                return (
                  <Row
                    key={account.sf_id}
                    accounts={accounts}
                    hasAccountParentBadge={hasAccountParentBadge && account.nb_children === account.children.length}
                    accountParentTooltip={accountParentTooltip}
                    row={{
                      id: account.id,
                      sf_id: account.sf_id,
                      label: account.name,
                      nb_children: account.nb_children,
                      count: account.children.length,
                      account,
                      disabled,
                      onDelete : onRemoveAccountParent
                    }}
                    subRows={_orderBy(account.children, 'label', order).map(r => ({
                      ...r,
                      disabled,
                      onDelete: handleDelete
                    }))}
                  />
                )
              })}
            </TableBody>
          </Table>
        </Box>
      </Box>
    </Box>
  )
}

export default CardSelection
